import {
  GET_CUSTOMER_ADDRESS_SUCCESS,
  CUSTOMER_ADDRESS_REQUESTING,
  LIST_CUSTOMER_ADDRESSES_SUCCESS,
  RESET_CUSTOMER_ADDRESS_ISFETCHING,
  DELETE_CUSTOMER_ADDRESS_SUCCESS,
  RESET_CUSTOMER_ADDRESS_QUERY
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false,
  query: null,
  recordCount: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CUSTOMER_ADDRESS_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case RESET_CUSTOMER_ADDRESS_QUERY: {
      return {
        ...state,
        query: null,
        recordCount: null
      };
    }
    case CUSTOMER_ADDRESS_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_CUSTOMER_ADDRESSES_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.customerAddresses.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        data,
        query,
        isFetching: false,
        recordCount: action.payload.total
      };
    }
    case GET_CUSTOMER_ADDRESS_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        isFetching: false,
        query: null,
        recordCount: null
      };
    }
    case DELETE_CUSTOMER_ADDRESS_SUCCESS: {
      const data = { ...state.data };
      delete data[action.payload.id];
      return {
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getDefaultAddress = (customerAddress) => {
  if (!customerAddress.data) {
    return null;
  }
  const customerAddressIds = Object.keys(customerAddress.data);
  const defaultAddressId = customerAddressIds.filter((id) => {
    if (customerAddress.data[id].isDefault) {
      return id;
    }
    return null;
  });
  if (defaultAddressId.length === 1) {
    return customerAddress.data[defaultAddressId[0]];
  }
  return null;
};

export const getNonDefaultAddresses = (customerAddress) => {
  if (!customerAddress.data) {
    return null;
  }
  const customerAddressIds = Object.keys(customerAddress.data);
  const nonDefaultIds = customerAddressIds.filter(
    (id) => !customerAddress.data[id].isDefault
  );
  return nonDefaultIds.map((id) => customerAddress.data[id]);
};
